// Global 401 handling (UX-72): an expired or invalidated session used to leave
// a signed-in-looking shell whose every page crashed. Wrap window.fetch once
// (from index.js) so any 401 from a business API announces itself; the
// PermissionContext listens and swaps the shell for the login page with a
// "signed out" explanation. /api/auth/* is excluded — a 401 there is a wrong
// password or code, not a dead session.
export const SESSION_EXPIRED_EVENT = "sgnic-session-expired";

export function installSessionWatch() {
  const origFetch = window.fetch.bind(window);
  window.fetch = async (input, init) => {
    const res = await origFetch(input, init);
    const url = typeof input === "string" ? input : (input && input.url) || "";
    if (res.status === 401 && url.startsWith("/api") && !url.startsWith("/api/auth/")) {
      window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
    }
    return res;
  };
}
